export default __webpack_public_path__ + "static/media/truck.94e3d8cf.png";